module.exports = __webpack_public_path__ + "static/Illu_Specials-e741497f27b1e966df75d3644f604f9b.svg";